import { useEffect } from "react";
import {
  clearTextSelection,
  clearSelection,
  makeSelection,
} from "./annotationSelection.js";

export function useFauxSelection(isSelectionActive, annotationMarkerRef) {
  // Create a faux selection state for the content to be annotated
  useEffect(() => {
    if (isSelectionActive) {
      // Select the target div in the DOM from our ref point
      const shrinkwrapDiv = annotationMarkerRef.current.closest(
        ".annotation-wrapper__shrinkwrap",
      );

      // If there's a "Create New Annotation" button, account for that
      const selectionTargetDiv =
        shrinkwrapDiv.firstElementChild.tagName === "BUTTON"
          ? shrinkwrapDiv.firstElementChild.nextSibling
          : shrinkwrapDiv.firstElementChild;

      // Clear any native browser text selection
      clearTextSelection();

      // Make our faux selection
      makeSelection(selectionTargetDiv);
      shrinkwrapDiv.classList.add("selection-is-active");

      return () => {
        // Clear the faux selection
        clearSelection(selectionTargetDiv);
        shrinkwrapDiv.classList.remove("selection-is-active");
      };
    }
  }, [annotationMarkerRef, isSelectionActive]);
}
